import ScrollTop from "./ScrollTop";
import Route from "../components/Route";
import Content from "../components/ContentHeader";

// css
import "react-toastify/dist/ReactToastify.css";
import "../css/SupportPage.css";

function PrivacyPolicy() {
  return (
    <div className="privacy_wrap">
      <ScrollTop />

      <Content title="개인정보 수집 및 이용" />

      <Route route1="RAINBOW BRAIN" route2="PRIVACY POLICY"></Route>

      <div className="content_bg">
        <div className="container">
          <div className="partners_box">
            <section className="privacy-policy">
              <h2 className="sub_title1">개인정보처리방침</h2>
              <p className="contents2">
                레인보우브레인(이하 '회사')은 개인정보 보호법을 준수하며, 고객의
                개인정보 보호를 위해 최선을 다하고 있습니다. 본
                개인정보처리방침은 회사가 제공하는 서비스 이용과 관련하여 고객의
                개인정보가 어떻게 수집, 이용, 보관, 파기되는지에 대해
                안내드립니다.
              </p>
              <br />
              <br />

              <h3 className="contents1">
                1. 수집하는 개인정보 항목 및 수집 방법
              </h3>
              <ul className="contents3">
                <li>
                  <strong>수집 항목:</strong> 이름, 이메일 주소, 소속, 직책,
                  전화번호
                </li>
                <li>
                  <strong>수집 방법:</strong> 홈페이지 문의, 상담 신청, 기술
                  자료 다운로드 등
                </li>
              </ul>

              <br />
              <h3 className="contents1">2. 개인정보의 수집 및 이용 목적</h3>
              <ul className="contents3">
                <li>
                  <strong>서비스 제공:</strong> 문의 응대, 상담, 기술 자료 제공
                  등
                </li>
                <li>
                  <strong>고객 관리:</strong> 서비스 이용 기록 관리, 고객 문의
                  대응 등
                </li>
                <li>
                  <strong>마케팅 및 홍보 (동의한 경우):</strong> 신규 서비스
                  안내, 이벤트 정보 제공 등
                </li>
              </ul>

              <br />
              <h3 className="contents1">3. 개인정보의 보유 및 이용 기간</h3>
              <p className="contents3">
                개인정보는 수집일로부터 1년간 보관되며, 이후 별도의 삭제 요청이
                없는 경우 관련 서비스 안내 및 콘텐츠 제공을 위한 동의 범위
                내에서 계속 보관·이용될 수 있습니다. 고객은 언제든지 개인정보
                삭제를 요청할 수 있으며, 요청 시 즉시 처리됩니다.
              </p>

              <br />
              <h3 className="contents1">4. 개인정보의 제3자 제공</h3>
              <p className="contents3">
                회사는 원칙적으로 고객의 개인정보를 외부에 제공하지 않습니다.
                다만, 법령의 규정에 따라 수사기관 등의 요청이 있는 경우
                예외적으로 제공될 수 있습니다.
              </p>

              <br />
              <h3 className="contents1">5. 개인정보의 파기 절차 및 방법</h3>
              <ul className="contents3">
                <li>
                  <strong>파기 절차:</strong> 보유 기간이 경과하거나 처리 목적이
                  달성된 경우, 개인정보는 즉시 파기됩니다.
                </li>
                <li>
                  <strong>파기 방법:</strong> 전자적 파일 형태의 정보는 복구
                  불가능한 방법으로 삭제하며, 종이 문서는 분쇄 또는 소각하여
                  파기합니다.
                </li>
              </ul>

              <br />
              <h3 className="contents1">6. 정보주체의 권리 및 행사 방법</h3>
              <p className="contents3">
                고객은 언제든지 개인정보 열람, 정정, 삭제, 처리 정지 등의 권리를
                행사할 수 있습니다. 이러한 요청은 이메일 또는 서면을 통해
                가능하며, 회사는 요청을 받은 즉시 조치합니다.
              </p>

              <br />
              <h3 className="contents1">7. 개인정보 보호책임자</h3>
              <ul className="contents3">
                <li>
                  <strong>담당:</strong> 레인보우브레인 개인정보 보호 담당
                </li>
                <li>
                  <strong>이메일:</strong>
                  <a href="mailto:contact@rbrain.co.kr">contact@rbrain.co.kr</a>
                </li>
              </ul>

              <br />
              <h3 className="contents1">8. 개인정보처리방침의 변경</h3>
              <p className="contents3">
                본 개인정보처리방침은 내부 방침에 따라 변경될 수 있으며, 변경
                사항은 사전 공지 합니다.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
